import React, { Component } from 'react';
import isMobile from 'utils/isMobile';

export default class ResizableComponent extends Component {
  constructor(props) {
    super(props);
    window.addEventListener('resize', this.handler);
  }

  handler = () => {
    let newMobile = isMobile();
    this.didResize(window.innerWidth, window.innerHeight, newMobile)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handler);
  }
}



// WEBPACK FOOTER //
// ./src/components/ResizableComponent.js